import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setShoeingItemToEdit, setShoeingModal } from '../../store/reducers/modal.reducer'
import { Box, Grid, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { LoadingButton } from '@mui/lab'
import { SubmitHandler, useForm } from 'react-hook-form'
import { TShoeing } from '../../shared/types/shoeing.type'
import { useAuth } from '../../hooks/useAuth'
import { get, isEmpty, isEqual, toNumber, update } from 'lodash'
import { useHorseShoeing } from '../../hooks/useHorseShoeing'
import { TUser } from '../../shared/types/user.type'

function Shoeing() {
    const open = useSelector<RootState>(state => state.modals.shoeingModal) as boolean
    const itemToEdit = useSelector<RootState>(state => state.modals.sheoingItemToEdit, isEqual) as TShoeing | null
    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const { saveShoeing, isSaving, updateShoeing, isUpdating } = useHorseShoeing(false)
    const dispatch = useDispatch()


    useEffect(() => {
        if (itemToEdit) {
            setValue('id', itemToEdit.id)
            setValue('name', itemToEdit?.name)
            setValue('brand', itemToEdit?.brand)
            setValue('material', itemToEdit?.material)
            setValue('weight', itemToEdit?.weight)
            setValue('trainer', itemToEdit?.trainer)
        }
    }, [itemToEdit])

    const {
        register,
        handleSubmit,
        reset,
        setValue,

        formState: { errors, touchedFields },
    } = useForm<Partial<TShoeing>>({
    })

    const onSubmit: SubmitHandler<Partial<TShoeing>> = (data) => {
        const tData: Partial<TShoeing> =
        {
            ...data,
            brand: isEmpty(data?.brand) ? null : data?.brand,
            material: isEmpty(data?.material) ? null : data?.material,
            weight: toNumber(data?.weight),
            trainer: get(auth, '@id')
        }
        let promise = itemToEdit ? updateShoeing(tData) : saveShoeing(tData)

        promise
            .then(() => {
                //On Success reset Form
                reset()
                dispatch(setShoeingItemToEdit(null))
            }).catch(err => { })
    }

    if (!open) return null

    return (
        <BaseModal title={itemToEdit ? 'tracks:information' : 'otherHorseShoeing'} open={open} handleClose={() => {
            dispatch(setShoeingModal(false))
            dispatch(setShoeingItemToEdit(null))
            reset()
        }}>
            <Box>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Grid container spacing={3}>

                        <Grid item md={12} xs={12}>
                            <TextField error={errors?.hasOwnProperty('name')} {...register('name', { required: true })} fullWidth label={t('equimetre:table:name')}></TextField>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <TextField {...register('brand')} fullWidth label={t('horseShoeing:brand')}></TextField>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <TextField {...register('material')} fullWidth label={t('horseShoeing:material')}></TextField>
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <TextField
                                inputProps={{
                                    step: "0.1"
                                }}
                                type='number' {...register('weight')} fullWidth label={t('parameters:weight') + '(G)'}></TextField>
                        </Grid>
                    </Grid>
                    <Box display={'flex'} mt={2} justifyContent={'end'}>
                        <LoadingButton loading={isSaving || isUpdating} type='submit' variant='contained'>{itemToEdit ? t('button:edit') : t('button:save')}</LoadingButton>
                    </Box>
                </form>
            </Box>

        </BaseModal>
    )
}

export default Shoeing